var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BasicDialog',{attrs:{"button-text":_vm.buttontText,"title":_vm.title},on:{"onClose":_vm.onClose,"onSubmit":_vm.onReactivation}},[_c('p',[_vm._v(_vm._s(_vm.paragraph1))]),_c('p',[_vm._v(_vm._s(_vm.paragraph2))]),_c('p',[_vm._v(_vm._s(_vm.paragraph3))])])
}
var staticRenderFns = []

export { render, staticRenderFns }